import axios from 'axios';
import { createContext, useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import Alert from './components/Alert';
import ConfirmDialogue from './components/ConfirmDialogue';
import LoadingSpinner from './components/LoadingSpinner';
import Navbar from './components/Navbar';
import Account from './pages/Account';
import AddStock from './pages/AddStock';
import DashBoard from './pages/DashBoard';
import Login from './pages/login/Login';
import OrdersTable from './pages/OrdersTable';
import SellStock from './pages/SellStock';
import SoldoutOrders from './pages/SoldoutOrders';
import StockTable from './pages/StockTable';

export const ProductContext = createContext();

function App() {
  document.body.classList.remove('remove-scroll');

  const [orderTableCategory, setOrderTableCategory] = useState('ordertable');
  const [user, setUser] = useState();

  const [confirmDialogue, setConfirmDialogue] = useState({ isOpen: false, message: '' });
  const [alert, setAlert] = useState({ isOpen: false, message: '', type: '' });

  const [isLoading, setIsLoading] = useState(false);

  const [productType, setProductType] = useState([]);
  const [soldDataSearchById, setSoldDataSearchById] = useState('');

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_SERVER_DOMAIN}/product-types`)
      .then(res => {
        let res_data = res.data.data;
        let temp = [];
        res_data.forEach(el => {
          temp.push(el.product_type);
        });
        setProductType(temp);
      })
      .catch(err => {
        setAlert({
          isOpen: true,
          message: "Something Went Wrong",
          type: "danger",
        });
      })

    if (localStorage.getItem('token')) {
      axios.get(`${process.env.REACT_APP_SERVER_DOMAIN}/users/get-user`, {
        headers: {
          Authorization: `Bearer ${JSON.parse(localStorage.getItem('token'))}`
        }
      })
        .then(res => {
          setUser(res.data.data);
        })
        .catch(err => {
          setAlert({
            isOpen: true,
            message: "Something Went Wrong",
            type: "danger",
          });
        })
    }
    setTimeout(() => {
      setAlert({ ...alert, isOpen: false });
    }, 5000);
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <ProductContext.Provider value={{
        orderTableCategory, setOrderTableCategory,
        alert, setAlert,
        confirmDialogue, setConfirmDialogue,
        isLoading, setIsLoading,
        productType,
        soldDataSearchById, setSoldDataSearchById,
        user, setUser,
      }}>
        <BrowserRouter>
          {isLoading ? <LoadingSpinner /> : null}
          {user ? <Navbar /> : null}
          <ConfirmDialogue />
          <Alert alert={alert} />
          <Routes>
            <Route exact path='/' element={user ? <DashBoard /> : <Login />} />
            <Route exact path='/stocktable' element={user ? <StockTable /> : <Login />} />
            <Route exact path='/addstock' element={user ? <AddStock /> : <Login />} />
            <Route exact path='/sellstock' element={user ? <SellStock /> : <Login />} />
            <Route exact path='/orderstable' element={user ? <OrdersTable /> : <Login />} />
            <Route exact path='/soldoutorder' element={user ? <SoldoutOrders /> : <Login />} />
            <Route exact path='/accounts' element={user?.role === 'admin' ? <Account /> : <Login />} />
            <Route exact path='/login' element={user ? <DashBoard /> : <Login />} />
          </Routes>
        </BrowserRouter>
      </ProductContext.Provider>
    </>
  );
}

export default App;
